import { Typography } from '@material-ui/core';

export default ({ text }: { text: string}) => <Typography sx={{ pt: 1, color: '#f44336', background: '#fafafa' }} variant="caption" component="p">{text}</Typography>;
